import { createContext } from 'react';
export var createEmotionContext = function createEmotionContext(emotion) {
  return /*#__PURE__*/createContext(emotion);
};